/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable object-curly-newline */
import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import './settings.css';
import DataTable from '../../components/DataTable';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { UserContext } from '../../contexts/User';
import { AccrualSchedule } from '../../constants/offTimePolicy';
import { NotificationContext } from '../../contexts/Notification';
import TabPageHeader from './TabPageHeader';
import ArchiveModal from './ArchiveModal';

function TimeoffArchivePanel({ getPolicies, isLoading, policies }) {
  const { activeWorkspace } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [selectedPolicy, setSelectedPolicy] = useState({});
  const [showModal, setShowModal] = useState(false);

  const handleClick = (policy) => {
    setSelectedPolicy(policy);
    setShowModal(true);
  };

  const restoreTimeOffPolicy = async () => {
    const res = await sendRequest({ method: 'put', url: API.WORKSPACE.restoreOffTimePolicy(activeWorkspace.id, selectedPolicy.id) });
    if (res.success) {
      displayNotification({ message: 'Successfully restored a PTO policy.', severity: 'success' });
      setShowModal(false);
      getPolicies();
    } else {
      displayNotification({ message: 'An error occurs while restoring a PTO policy.', severity: 'error' });
    }
  };

  useEffect(() => {
    getPolicies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rows = (policies || []).filter((p) => p.isArchived);

  const columns = [
    { key: 'name', label: 'Policy Name', sortable: true, width: 240, flex: true, render: (p) => <span className="font-medium text-ink-900">{p.name}</span> },
    { key: 'members', label: 'Members', sortable: true, width: 110, render: (p) => <span className="tabular-nums text-ink-700">{p.members.length}</span> },
    { key: 'teams', label: 'Teams', sortable: true, width: 100, render: (p) => <span className="tabular-nums text-ink-700">{p.teams.length}</span> },
    { key: 'accrual', label: 'Accrual Schedule', sortable: true, width: 180, render: (p) => <span className="text-ink-700">{AccrualSchedule[p.scheduleOfAccrual]?.text}</span> },
    {
      key: 'action',
      label: 'Action',
      width: 130,
      render: (p) => (
        <button type="button" onClick={() => handleClick(p)} className="inline-flex items-center justify-center px-3 py-1.5 rounded-[8px] text-[11px] font-semibold uppercase tracking-wider text-ink-900 bg-white border border-rule hover:border-brand-500 hover:text-brand-700 transition whitespace-nowrap" style={{ borderStyle: 'solid', letterSpacing: '0.05em' }}>
          Restore
        </button>
      ),
    },
  ];

  return (
    <>
      <TabPageHeader title="Archived time off policies" subtitle="Restore the policies below to use them again" />
      <DataTable bare columns={columns} rows={rows} getRowKey={(p) => p.id} loading={isLoading} emptyText="No archived policies." minWidth={760} />
      {showModal && (
        <ArchiveModal
          title="Restore this policy?"
          description="The policy will be restored and can be used again to add new members."
          policyName={selectedPolicy.name}
          setShowModal={setShowModal}
          callback={restoreTimeOffPolicy}
          buttonName="Restore"
        />
      )}
    </>
  );
}

TimeoffArchivePanel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  policies: PropTypes.array,
  getPolicies: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

TimeoffArchivePanel.defaultProps = { policies: [] };

export default TimeoffArchivePanel;
